function filterEventHandler(event) {
  const $this = $(this);
  event.preventDefault();

  // Try to get form using this.form
  // In case of failure (foundation slider etc)
  // use jquery to get closest form
  const $form = $(this.form || $this.closest('form'));

  if ($form.closest('[data-off-canvas]').is('.is-open')) {
    $form.append('<input type="hidden" name="is_filter_open" value="1">');
  }

  const url = `${$form.attr('action')}?${$form.serialize()}`;
  $.stores.itemlist.filter(url);
}

$(document).on(
  'change',
  '[data-kombitool-filter] input[type="radio"]',
  filterEventHandler,
);
